export const getDatagraphAlertStates = (state)=> state.alertReducer.DataGraphAlertReducer
export const getAlertDailogStates = (state)=> state.alertReducer.AlertDialogReducer